const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class RecommendedProducts extends window.BAO.CustomElement() {
  connectedCallback () {
    this.carousel = this.setupCarousel()

    if (this?.els?.complementary?.exists) {
      this.checkComplementaryProducts()
    }

    this.showComplementaryProducts = this.showComplementaryProducts.bind(this)

    if (this?.els?.['complementary-title']?.exists) {
      this.listeners.add(
        this.els['complementary-title'].element,
        `click`,
        this.showComplementaryProducts,
      )
    }

    this.showRelatedProducts = this.showRelatedProducts.bind(this)

    if (this?.els?.['related-title']?.exists) {
      this.listeners.add(
        this.els['related-title'].element,
        `click`,
        this.showRelatedProducts,
      )
    }
  }

  async checkComplementaryProducts () {
    await fetch(
      `${window.Shopify.routes.root}recommendations/products.json?product_id=${window.meta.product.id}&limit=1&intent=complementary`,
    )
      .then(response => response.json())
      .then(({ products }) => {
        if (products.length > 0) {
          if (this?.els?.['complementary-title']?.exists) {
            this.els['complementary-title'].element.removeAttribute(
              'aria-hidden',
            )
          }

          this.loadComplementaryProducts()
        }
      })
  }

  showRelatedProducts () {
    if (this?.els?.complementary?.exists) {
      this.els.complementary.element.setAttribute('aria-hidden', 'true')
    }

    if (this?.els?.related?.exists) {
      this.els.related.element.setAttribute('aria-hidden', 'false')
    }

    if (this?.els?.['complementary-title']?.exists) {
      this.els['complementary-title'].element.setAttribute(
        'aria-selected',
        'false',
      )
    }

    if (this?.els?.['related-title']?.exists) {
      this.els['related-title'].element.setAttribute('aria-selected', 'true')
    }
  }

  showComplementaryProducts () {
    if (this?.els?.complementary?.exists) {
      this.els.complementary.element.setAttribute('aria-hidden', 'false')
    }

    if (this?.els?.related?.exists) {
      this.els.related.element.setAttribute('aria-hidden', 'true')
    }

    if (this?.els?.['complementary-title']?.exists) {
      this.els['complementary-title'].element.setAttribute(
        'aria-selected',
        'true',
      )
    }

    if (this?.els?.['related-title']?.exists) {
      this.els['related-title'].element.setAttribute('aria-selected', 'false')
    }
  }

  async loadComplementaryProducts () {
    await window.BAO.sectionRenderer
      .fetchSingle('section-recommended-products-complementary-tab')
      .then(res => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.shopify-section')

        this.els.complementary.element.innerHTML = myself.innerHTML
      })
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.07,
          spacing: 15,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 2.7,
              spacing: 30,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 4.05,
              spacing: 30,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('recommended-products')) {
  customElements.define('recommended-products', RecommendedProducts)
}

class PushCartRecommendedProducts extends RecommendedProducts {
  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.07,
          spacing: 15,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 1.15,
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('push-cart-recommended-products')) {
  customElements.define(
    'push-cart-recommended-products',
    PushCartRecommendedProducts,
  )
}
